var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlightPermission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#FDEAD7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 32,
    height: 32,
    rx: 16,
    stroke: "#FDEAD7",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 13.4333C18.6667 13.4333 18.3806 13.3139 18.1417 13.075C17.9028 12.8361 17.7834 12.55 17.7834 12.2167C17.7834 11.8833 17.9028 11.5972 18.1417 11.3583C18.3806 11.1194 18.6667 11 19 11C19.3334 11 19.6195 11.1194 19.8584 11.3583C20.0973 11.5972 20.2167 11.8833 20.2167 12.2167C20.2167 12.55 20.0973 12.8361 19.8584 13.075C19.6195 13.3139 19.3334 13.4333 19 13.4333ZM15.2334 25.3333C15.0667 25.3333 14.9361 25.275 14.8417 25.1583C14.7473 25.0417 14.7167 24.9056 14.75 24.75L16.5834 15.5167L14.8834 16.2833V18C14.8834 18.1333 14.8334 18.25 14.7334 18.35C14.6334 18.45 14.5167 18.5 14.3834 18.5C14.2389 18.5 14.1167 18.45 14.0167 18.35C13.9167 18.25 13.8667 18.1278 13.8667 17.9833V16.2833C13.8667 16.0833 13.9223 15.9 14.0334 15.7333C14.1445 15.5667 14.2945 15.4444 14.4834 15.3667L17.0667 14.2667C17.3778 14.1333 17.7139 14.1 18.075 14.1667C18.4361 14.2333 18.7111 14.4056 18.9 14.6833L19.6 15.7833C19.8556 16.2056 20.2 16.5722 20.6334 16.8833C21.0667 17.1944 21.5667 17.3889 22.1334 17.4667C22.2556 17.4889 22.3556 17.5417 22.4334 17.625C22.5111 17.7083 22.55 17.8111 22.55 17.9333C22.55 18.0889 22.4945 18.2222 22.3834 18.3333C22.2723 18.4444 22.1389 18.4889 21.9834 18.4667C21.3723 18.3889 20.8167 18.1833 20.3167 17.85C19.8167 17.5167 19.3556 17.0556 18.9334 16.4667L18.25 19.0667L19.45 20.15C19.5611 20.25 19.6445 20.3639 19.7 20.4917C19.7556 20.6194 19.7834 20.7556 19.7834 20.9V24.8333C19.7834 24.9778 19.7361 25.0972 19.6417 25.1917C19.5473 25.2861 19.4278 25.3333 19.2834 25.3333C19.1389 25.3333 19.0195 25.2861 18.925 25.1917C18.8306 25.0972 18.7834 24.9778 18.7834 24.8333V21.3333L16.9834 19.7L15.7667 24.9167C15.7445 25.0389 15.6806 25.1389 15.575 25.2167C15.4695 25.2944 15.3556 25.3333 15.2334 25.3333Z",
    fill: "#FF4405"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlightPermission);
export default __webpack_public_path__ + "static/media/alightPermission.fea27668dcea23fead1ef7729e9f5c8c.svg";
export { ForwardRef as ReactComponent };